import React from 'react';
import PropTypes from 'prop-types';
import { icons } from 'smartsuite-ui';
import MenuItem from '@material-ui/core/MenuItem';
import useLink from '../../../shared/hooks/linkHooks';
import { useLabelContext } from '../../../shared/hooks/labelContext';

export default function WidgetContextMenuActionLink(props) {
    const { dashboardLabels } = useLabelContext();
    const linkUri = useLink(props.action, props.metricRequest, {
        [props.action.dataKey]: props.dataItem.name,
    });

    function onLinkActionClick() {
        window.open(linkUri, props.openLinksInNewTab ? '_blank' : '');
        props.onClose();
    }

    return (
        <MenuItem key={props.action.valueKey} onClick={onLinkActionClick}>
            <span className={`${icons.search} widget-context-menu__icon`} />
            <span>
                {`${dashboardLabels.view} ${
                    props.dataItem.values[props.action.valueKey]
                } ${props.action.label}`}
            </span>
        </MenuItem>
    );
}

WidgetContextMenuActionLink.propTypes = {
    action: PropTypes.instanceOf(Object).isRequired,
    dataItem: PropTypes.instanceOf(Object).isRequired,
    metricRequest: PropTypes.instanceOf(Object).isRequired,
    onClose: PropTypes.func.isRequired,
    openLinksInNewTab: PropTypes.func.isRequired,
};
